import { CompletedTaskCustomData } from '../../datapoints';
import { now, differenceInMilliseconds } from 'owa-datetime';
import selectTodoById from '../../selectors/selectTodoById';

export default function getCompletedTaskCustomData(todoId: string): CompletedTaskCustomData {
    return {
        differenceFromDueDate: getDifferenceFromDueDate(todoId),
        differenceFromReminderDate: getDifferenceFromReminderDate(todoId),
    };
}

function getDifferenceFromDueDate(todoId: string): number {
    const item = selectTodoById(todoId);

    if (!item) {
        return null;
    }

    const dueDate = item.DueDateTime;
    return dueDate ? differenceInMilliseconds(dueDate, now()) : null;
}

function getDifferenceFromReminderDate(todoId: string): number {
    const item = selectTodoById(todoId);

    if (!item) {
        return null;
    }
    const reminderDate = item.ReminderDateTime;
    return reminderDate ? differenceInMilliseconds(reminderDate, now()) : null;
}
